import React, { Component } from 'react'
import { connect } from 'react-redux'

import { isTouchDevice } from '../../../utils/detect'

// import styles
import './newordersmodal.scss'

// Utils
import { translation } from '../../../utils/helpers'

// import components
import Modal from '../../components/Modal'
// import Button from '../../../shared/elements/button'
import NewPaintDraft from './NewPaintDraft'
import NewBodyDraft from './NewBodyDraft'

// import Popup from '../../../shared/elements/popup'

import { ModalIcons } from '../../elements/icons'

// Actions
import { uploadImageMarkings } from '../../../actions/orders'

// Language
import {InitLanguage, setTranslations, setLanguage, setLanguages} from '../../../language'
import { setPhoneCodes, setBrands, setEnums, setCountries } from '../../../actions/common'

// Redux
import store from '../../../store'
// import popupHeader from '../../elements/popupHeader'

class NewOrdersModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      tabView: 'draft',
      headerTitle: '14802',
      onClose: this.onClose,
      overflowHidden: false,
      bottomBarProps: {}
    }

    this.uploadImageMarkings = this.uploadImageMarkings.bind(this)
    this.onClose = this.onClose.bind(this)
    this.redirectToOrder = this.redirectToOrder.bind(this)
    this.updateModal = this.updateModal.bind(this)
    this.onDraftCreated = this.onDraftCreated.bind(this)
  }

  resetState (props) {
    let newState = {
      tabView: 'draft',

      headerTitle: '14802',
      onClose: this.onClose,
      overflowHidden: false
    }
    return newState
  }

  componentDidMount () {
    this.setState(this.resetState())

    // get resources if missing
    let common = this.props.common
    if (common.phonecodes.length === 0 ||
      common.brands.length === 0 ||
      common.countries.length === 0) {
      InitLanguage().then((res) => {
        // Set translations
        store.dispatch(setTranslations(res.translations))
        store.dispatch(setLanguages(res.langs))

        // Set rest
        store.dispatch(setPhoneCodes(res.data.PhoneCodes))
        store.dispatch(setBrands(res.data.Brands))
        store.dispatch(setEnums(res.data.Enums))
        store.dispatch(setCountries(res.data.Countries))

        // Set user language
        if (typeof window.localStorage.user_language !== 'undefined') {
          store.dispatch(setLanguage(window.localStorage.user_language))
        }
      })
    }
  }

  // componentWillReceiveProps (nextProps) {
  //   if (!isEqual(nextProps, this.props)) {
  //     this.setState(this.resetState(nextProps))
  //   }
  // }

  uploadImageMarkings (images) {
    let uploadedFiles = images
    let finishedFiles = []
    let imageMarkings = []
    let orderFileIds = []

    uploadedFiles.forEach(file => {
      finishedFiles = [...finishedFiles, { OrderFileId: file.OrderFileID }]
      // orderFileIds.push(val.OrderFileID)

      let markings = []
      if (file.circles !== undefined) {
        markings = file.circles.map(circle => {
          return {
            PositionX: circle.left,
            PositionY: circle.top,
            Scale: parseFloat(circle.scale.toFixed(2)),
            Size: 50
          }
        })
      }
      if (markings.length !== 0 || file.rotation) {
        const img = {
          ImageSize: file.ImageSize,
          OrderFileID: file.OrderFileID,
          Markings: markings,
          Rotation: file.rotation
        }
        imageMarkings = [...imageMarkings, img]
      }
    })

    let inputs = document.getElementsByTagName('input')
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i].name === 'checkbox_image' && inputs[i].checked === true) {
        finishedFiles.push({
          OrderFileId: inputs[i].id
        })
        orderFileIds.push(inputs[i].id)
      }
    }

    if (imageMarkings.length !== 0) {
      return this.props.uploadImageMarkings(imageMarkings)
    } else {
      return Promise.resolve()
    }
  }

  redirectToOrder (orderId) {
    this.props.onClose()
    console.log('Redirect to order...', orderId, this.props.options)
    let routeState = { createdNew: true }
    if (this.props.options) {
      routeState.assignments = []
      if (this.props.options.employee && this.props.options.steps) {
        routeState.assignments.push({ userId: this.props.options.employee.UserId, steps: this.props.options.steps })
      }
      routeState.bookingDestination = this.props.options.bookingDestination
    }
    console.log('RouteState: ', routeState)
    // this.props.router.push('/orders/' + orderId)
    this.props.router.push({
      pathname: '/orders/' + orderId,
      state: routeState
    })
  }

  updateModal ({ tabView, headerTitle, onModalClose, overflowHidden, bottomBarProps }) {
    const data = {}

    if (tabView) data.tabView = tabView
    if (headerTitle) data.headerTitle = headerTitle
    if (onModalClose) data.onClose = onModalClose
    // if (isCircleimageOpen) data.isCircleimageOpen = isCircleimageOpen
    if (overflowHidden) data.overflowHidden = overflowHidden
    if (bottomBarProps) data.bottomBarProps = bottomBarProps

    this.setState(data)
  }

  onClose () {
    if (this.state.tabView === 'image') {
      this.setState({
        tabView: 'draft'
      })
    } else {
      this.props.onClose()
    }
  }

  onDraftCreated (orderId) {
    console.log('Draft created')
    this.props.onDraftCreated && this.props.onDraftCreated(orderId)
  }

  render () {
    let modalClass = 'neworder__modal'
    if (isTouchDevice() && this.props.bodyShop) {
      modalClass = 'touch neworder__modal'
    }
    if (this.state.tabView === 'image') {
      modalClass = 'circleimage_modal'
    }

    const draftProps = {
      tabView: this.state.tabView,
      uploadImageMarkings: this.uploadImageMarkings,
      redirectToOrder: this.redirectToOrder,
      modal: this.refs.modal,
      updateModal: this.updateModal,
      onModalClose: this.props.onClose,
      router: this.props.router
      // newOrderModalWidth: this.state.newOrderModalWidth
    }
    let view
    if (this.props.bodyShop) {
      view = <NewBodyDraft {...draftProps} carRentalDefaultInfo={this.props.carRentalDefaultInfo} options={this.props.options} onDraftCreated={this.onDraftCreated} />
    } else {
      view = <NewPaintDraft {...draftProps} />
    }

    let bottomBarProps = null
    if (this.state.tabView === 'draft' || this.state.tabView === 'complaint') {
      bottomBarProps = {
        disabled: (loading) => loading,
        ...this.state.bottomBarProps
      }
    }

    // return (
    //   <Popup popupId='newOrder' ref='modal'>
    //     <popupHeader>{translation(this.state.headerTitle)}</popupHeader>
    //     {view}
    //   </Popup>
    // )

    return (
      <div className={modalClass}>
        <Modal ref='modal' {...this.props}
          header={translation(this.state.headerTitle)}
          overflowHidden={this.state.overflowHidden}
          clickOutsideClose={false}
          onClose={this.state.onClose}
          icon={ModalIcons.Plus}
          bottomBarProps={bottomBarProps}
        >
          {view}
        </Modal>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    common: state.common
  }
}

export default connect(mapStateToProps, {
  uploadImageMarkings
})(NewOrdersModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewOrdersModal/index.js